import { getStudents } from '@/app/services/reports/reports';
import { getAllRooms } from '@/app/services/rooms/rooms';
import * as Actions from '@/app/store/actions';
import FilterIcon from '@shared/icons/FilterIcon';
import { Divider } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import PopoverCombobox from '@shared/Reports/PopoverCombobox';
import PopoverMultiselect from '@shared/Reports/PopoverMultiselect';
import PopoverSelect from '@shared/Reports/PopoverSelect';

const ContactsFiltersBar = ({ filters, setFilters }) => {
	const [students, setStudents] = useState([]);
	const [rooms, setRooms] = useState([]);
	const [roomsLoading, setRoomsLoading] = useState(true);
	const [allStdPage, setAllStdPage] = useState(1);
	const [studentsLoading, setStudentsLoading] = useState(true);
	const dispatch = useDispatch();

	useEffect(() => {
		let isMounted = true;
		const fetchStudents = async () => {
			try {
				const res = await getStudents('', allStdPage);
				setStudentsLoading(false);
				if (!isMounted) return;
				if (!filters.roomId) {
					setStudents([...students, ...res.data.data]);
					if (res.data.current_page < res.data.last_page) {
						setAllStdPage(allStdPage + 1);
					}
				}
			} catch (error) {
				dispatch(
					Actions.showMessage({
						message: 'Failed to fetch students',
						variant: 'error',
					}),
				);
				setStudentsLoading(false);
			}
		};
		fetchStudents();
		return () => {
			isMounted = false;
		};
	}, [allStdPage]);

	useEffect(() => {
		const fetchRooms = async () => {
			try {
				setRoomsLoading(true);
				const res = await getAllRooms();
				setRooms(res.data);
				setRoomsLoading(false);
			} catch (error) {
				dispatch(
					Actions.showMessage({
						message: 'Failed to fetch rooms',
						variant: 'error',
					}),
				);
				setRoomsLoading(false);
			}
		};
		fetchRooms();
	}, []);

	return (
		<div className="text-white py-16 px-32 justify-between flex" style={{ background: 'rgb(0, 46,108)' }}>
			<span className="flex items-center gap-8 text-16">
				<FilterIcon /> Filter:
			</span>
			<div className="flex gap-8 md:gap-16">
				<PopoverCombobox
					currentFilter="room_id"
					filters={filters}
					options={
						roomsLoading
							? []
							: rooms?.map((room) => {
									return { label: room?.name, value: room?.id };
								})
					}
					setFilter={setFilters}
					title="Room"
				/>
				<Divider className="bg-white" flexItem orientation="vertical" />
				<PopoverCombobox
					currentFilter="student_id"
					filters={filters}
					options={
						studentsLoading
							? []
							: students?.map((student) => {
									return {
										label: `${student?.first_name} ${student?.last_name}`,
										value: student?.id,
									};
								})
					}
					setFilter={setFilters}
					title="Student"
				/>
				<Divider className="bg-white" flexItem orientation="vertical" />
				<PopoverSelect
					currentFilter="status"
					filters={filters}
					options={[
						{ label: 'Active', value: true },
						{ label: 'Inactive', value: false },
					]}
					setFilter={setFilters}
					title="Student Status"
				/>{' '}
				<Divider className="bg-white" flexItem orientation="vertical" />
				<PopoverMultiselect
					currentFilter="contact_type"
					filters={filters}
					options={[
						{ label: 'Parents/Legal Guardians', value: 'parent' },
						{ label: 'Other', value: 'extended_family' },
					]}
					setFilter={setFilters}
					title="Relation"
				/>
				<Divider className="bg-white" flexItem orientation="vertical" />
				<PopoverMultiselect
					currentFilter="privileges"
					filters={filters}
					options={[
						{ label: 'Emergency Contact', value: 'emergency_contact' },
						{ label: 'Pickup Authorized', value: 'can_pickup' },
						{ label: 'App Access', value: 'app_access' },
					]}
					setFilter={setFilters}
					title="Privileges"
				/>{' '}
			</div>
		</div>
	);
};

export default ContactsFiltersBar;
